import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UTMdataFilter } from "../../../../helper";
import { fetchGraphUTMCampaign } from "./utmCampaignAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  percentBooking: [],
  percentBought: [],
  weeks: [],
  labels: [],
};

export const graphUTMCampaign = createAsyncThunk(
  "utmCampaign/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-utm_campaign`;
      const response = await fetchGraphUTMCampaign(dbpath, user, 'graph-utm_campaign');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmCampaignSlice = createSlice({
  name: "utmCampaign",
  initialState,
  reducers: {
    resetUtmCampaign: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMCampaign.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMCampaign.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result;
          const resultData = utmCampaignHandler(result, "utm_campaign=");
          state.visitors = resultData.visitors.reverse();
          state.percentBooking = resultData.percentBooking.reverse();
          state.percentBought = resultData.percentBought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          // console.warn("UTMCampaign data not found!", error)
        }

      })
      .addCase(graphUTMCampaign.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetUtmCampaign} = utmCampaignSlice.actions;


export const SelectVisitors = (state) => state.utmCampaign.visitors;
export const SelectPercentBooking = (state) => state.utmCampaign.percentBooking;
export const SelectPercentBought = (state) => state.utmCampaign.percentBought;
export const SelectLabels = (state) => state.utmCampaign.labels;
export const SelectWeeks = (state) => state.utmCampaign.weeks;
export const SelectUTMCampaignStatus = (state) => state.utmCampaign.status;

export default utmCampaignSlice.reducer;

export const utmCampaignHandler = (data, utmParam) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    percentBooking: [],
    percentBought: [],
    labels: [],
  };

  const resultData =  UTMdataFilter(data, resultObj, utmParam);
  return resultData;
};

